// extracted by mini-css-extract-plugin
export default {"select":"BaseSelectTaggable_select_s_ITR","multiple":"BaseSelectTaggable_multiple_wQBpB","error":"BaseSelectTaggable_error_k0H2c","error_txt":"BaseSelectTaggable_error_txt_i436Z"};